import React from 'react';
import { UserAgentApplication } from 'msal';
import EUAScreenSpinner from '../../components/EUAScreenSpinner';

export const msalConfig = {
  authority: 'https://login.microsoftonline.com/72f988bf-86f1-41af-91ab-2d7cd011db47',
  clientId: process.env.REACT_APP_UICLIENTID,
  redirectUri: document.getElementById('root').baseURI,
  navigateToLoginRequestUrl: true,
};
const loginRequest = { scopes: [`api://${msalConfig.clientId}/user_impersonation`] };
export const msalAuth = new UserAgentApplication({
  auth: msalConfig,
});
export interface IMSALState {
  isAuthenticated: boolean;
  user: any;
  hasError: boolean;
  errorMessage: any;
  isExternalUser: boolean;
}
export function withAuth(HocComponent) {
  return class extends React.Component<{}, IMSALState> {
    constructor(props) {
      super(props);

      this.state = {
        isAuthenticated: false,
        user: {},
        hasError: false,
        errorMessage: null,
        isExternalUser: false,
      };
    }

    async componentDidMount() {
      const allowedDomainsSetting = process.env.REACT_APP_ALLOWED_DOMAINS;
      const internalUsers = allowedDomainsSetting ? allowedDomainsSetting.split(';') : [];
      const isRedirectCallback = msalAuth.isCallback(window.location.hash);
      msalAuth.handleRedirectCallback(
        (authResponse) => {
          let userAccount = msalAuth.getAccount();

          if (!authResponse.accessToken) {
            msalAuth.acquireTokenRedirect(loginRequest);
            return;
          }

          this.setState({
            isAuthenticated: true,
            user: userAccount,
            isExternalUser: !(internalUsers?.find((x) => userAccount?.userName?.includes(x)) != null),
          });
          let urlvalue = sessionStorage.getItem('url');
          sessionStorage.removeItem('url');
          if (urlvalue && urlvalue !== window.location.href) {
            try {
              const redirectUrl = new URL(urlvalue, window.location.origin);
              if (redirectUrl.origin === window.location.origin) {
                window.location.href = redirectUrl.href;
              }
            } catch {
              /* invalid URL, ignore */
            }
          }
        },
        (authErr, accountState) => {
          // on fail
          console.log(authErr);

          this.setState({
            hasError: true,
            errorMessage: authErr.errorMessage,
          });
        }
      );

      if (isRedirectCallback) {
        return;
      }

      let userAccount = msalAuth.getAccount();

      if (!userAccount) {
        let isInProgress = msalAuth.getLoginInProgress();
        if (isInProgress) {
          console.log('Sign in already in Progress ');
        } else {
          console.log('Redirecting...');
          sessionStorage.setItem('url', window.location.href);
          msalAuth.loginRedirect(loginRequest);
          return;
        }
      } else {
        this.setState({
          isAuthenticated: true,
          user: userAccount,
          isExternalUser: !(internalUsers?.find((x) => userAccount?.userName?.includes(x)) != null),
        });
      }
    }

    onSignIn() {
      msalAuth.loginRedirect(loginRequest);
    }

    onSignOut() {
      msalAuth.logout();
    }

    render() {
      const { isAuthenticated, hasError } = this.state;
      if (isAuthenticated) {
        return (
          <HocComponent
            auth={this.state}
            onSignIn={() => this.onSignIn()}
            onSignOut={() => this.onSignOut()}
            {...this.props}
          />
        );
      }

      if (hasError) {
        return <div>{this.state.errorMessage}</div>;
      }

      return <EUAScreenSpinner message={'Signing In'}></EUAScreenSpinner>;
    }
  };
}
